import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { DataChannelSessionIntentionPromptAcknowledgedMessage } from '../../video-sdk';
import { inSessionPatientInformationAtom } from '../state';

export function useHandleSessionIntentionPromptAcknowledgedCallback() {
  const setInSessionPatientInformation = useSetAtom(inSessionPatientInformationAtom);

  return useCallback(
    async (message: DataChannelSessionIntentionPromptAcknowledgedMessage) => {
      const patientShortId = message.sender.entityId;
      const { response, acknowledgedAt } = message.prompt;

      if (response != 'COMPLETED') {
        return;
      }

      setInSessionPatientInformation((prev) => {
        if (!prev || prev.patientShortId !== patientShortId) return prev;

        return {
          ...prev,
          intentionCompletedAt: acknowledgedAt,
        };
      });
    },
    [setInSessionPatientInformation],
  );
}
